export default __webpack_public_path__ + "media/images/mailer/logo-db1b70bfa364d72a8e2bd7b81490d5d4.png";